import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Hypercholesterolemia(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-03-hepatitis-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"High cholesterol (hypercholesterolemia) "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    High cholesterol is when <b>you have too much of a fatty
                                        substance called cholesterol in your blood</b>. It's mainly caused
                                    by eating fatty food, not exercising enough, being overweight,
                                    smoking and drinking alcohol. It can also run in families. You can
                                    lower your cholesterol by eating healthily and getting more
                                    exercise.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/hypercholesterolemia/1.png")} alt="hepatitis" />
                                    </div>
                                </div>
                               
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>High cholesterol has no symptoms.</p>
                                <p>Can have no symptoms, but people may experience:</p>
                                <p><b>Common symptoms:</b> heart attack, peripheral artery disease, or stroke</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Hypercholesterolemia">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Hypercholesterolemia;